export const TOKEN_STORAGE_KEY = "token";
export const BUSINESS_ID_STORAGE_KEY = "businessId";
export const AFFILIATE_CODE_STORAGE_KEY = "affiliateCode";
export const LOGIN_PATH = "/login";
export const MAX_TOKEN_EXPIRY_TIMEOUT_MS = 2147483647;

type JwtPayload = {
  exp?: number | string;
  [key: string]: unknown;
};

const decodeBase64Url = (value: string) => {
  const base64 = value.replace(/-/g, "+").replace(/_/g, "/");
  const paddingLength = base64.length % 4;
  const padding = paddingLength ? Array(5 - paddingLength).join("=") : "";

  return atob(base64 + padding);
};

export const getJwtPayload = (token: string): JwtPayload | null => {
  const payload = token.split(".")[1];

  if (!payload) {
    return null;
  }

  try {
    return JSON.parse(decodeBase64Url(payload));
  } catch {
    return null;
  }
};

export const getTokenExpirationTime = (token: string) => {
  const payload = getJwtPayload(token);
  const exp = Number(payload?.exp);

  if (!isFinite(exp)) {
    return null;
  }

  return exp * 1000;
};

export const isTokenExpired = (token: string) => {
  const expirationTime = getTokenExpirationTime(token);

  return !expirationTime || Date.now() >= expirationTime;
};

export const clearAuthSession = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem(TOKEN_STORAGE_KEY);
  window.localStorage.removeItem(BUSINESS_ID_STORAGE_KEY);
  window.localStorage.removeItem(AFFILIATE_CODE_STORAGE_KEY);
};

export const getStoredAuthToken = () => {
  if (typeof window === "undefined") {
    return "";
  }

  const token = window.localStorage.getItem(TOKEN_STORAGE_KEY);

  if (!token) {
    return "";
  }

  try {
    const parsedToken = JSON.parse(token);

    return typeof parsedToken === "string" ? parsedToken : "";
  } catch {
    return token;
  }
};
